var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStake = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.092.708c-.594 0-1.075.481-1.075 1.075v2.259h-1.45c-.593 0-1.074.48-1.074 1.074v2.435c0 .593.48 1.074 1.074 1.074h1.72v2.084a1.074 1.074 0 0 0-1.033 1.074v2.434c0 .594.48 1.075 1.074 1.075H13.4c.593 0 1.074-.481 1.074-1.075v-2.26a1.074 1.074 0 0 0 1.033-1.073V8.45c0-.593-.48-1.074-1.074-1.074h-1.72V5.292h1.45c.594 0 1.075-.481 1.075-1.075V1.783c0-.594-.481-1.075-1.074-1.075H4.092Zm.175 3.334V1.958h9.72v2.084h-9.72Zm-2.524 1.25v2.083h9.72V5.292h-9.72Zm2.794 5.416V8.625h9.72v2.083h-9.72Zm-1.033 3.334v-2.084h9.72v2.084h-9.72Z",
    fill: "#fff"
  })));
};
export default SvgStake;